<template>
  <div class="auth-container">
    <!-- 登录弹框 手机/PC端手机号/验证码登录弹框-->
    <loginDialog
      ref="loginDialog"
      :streamId="Number(roomNum)"
      @needRegister="needRegister"
      @loginSuccess="loginSuccess"
      @loginFail="loginFail"
      @visitorLogin="visitorLogin"
      @lookPolicy="lookPolicy"
    ></loginDialog>
    <!-- 手机号绑定弹框 -->
<!--    <phoneBindDialog-->
<!--      ref="phoneBindDialog"-->
<!--      :streamId="Number(roomNum)"-->
<!--      @bindSuccess="bindSuccess"-->
<!--      @bindFail="bindFail"-->
<!--      @lookPolicy="lookPolicy"-->
<!--    ></phoneBindDialog>-->
    <!-- 邮箱验证码登录弹框 -->
    <emailLoginDialog
      ref="emailLoginDialog"
      :streamId="Number(roomNum)"
      @loginSuccess="loginSuccess"
      @loginFail="emailLoginFail"
      @visitorLogin="visitorLogin"
      @lookPolicy="lookPolicy"
    ></emailLoginDialog>
    <!-- 姓名医院登录-->
    <nameHospitalDialog
      ref="nameHospitalDialog"
      :streamId="Number(roomNum)"
      :livingMeetingId="Number($route.query.live_meeting_id || -1)"
      :conventionId="conventionId"
      @loginSuccess="nameHospitalSuccess"
      @lookPolicy="lookPolicy"
    ></nameHospitalDialog>
    <!-- 完善资料 -->
    <perfectDialog
        v-if="perfectDialogIsShow"
      ref="perfectDialog"
      :dataForm="dataForm"
      :phone="perfectPhone"
      @perfectSuccess="perfectSuccess"
    ></perfectDialog>
    <!-- 隐私条款 -->
    <policyDialog
      ref="policyDialog"
      :room="roomNum"
      @agreePolicy="agreePolicy"
    ></policyDialog>
    <!--开屏广告-->
    <advertisementModal ref="advertisementModal" @countEnd="advertiseEnd"></advertisementModal>
    <!--无权限提示-->
    <noauthDialog ref="noauthDialog" @ensure="whichLoginType"></noauthDialog>
  </div>
</template>

<script>

import { postCheckLoginPay, postUserInfo, postLiveMeetDetail, postMettingDetail
  // , wechatOfficeLogin
} from '@/models/common'
import cryptoJs from 'crypto-js'
import loginDialog from '@/views/home/components/login-dialog'
// import phoneBindDialog from '@/views/home/components/phone-bind-dialog'
import emailLoginDialog from '@/views/home/components/email-login-dialog'
import policyDialog from '@/views/home/components/policy-dialog'
import nameHospitalDialog from '@/views/home/components/name-hospital-dialog'
import perfectDialog from '@/views/home/components/perfect-dialog'
import noauthDialog from '@/views/home/components/noAuth-dialog'
import advertisementModal from '@/views/home/components/advertisement-modal'
import { IsWx } from '@/utils/index.js'
export default {
  components: {
    loginDialog,
    // phoneBindDialog,
    policyDialog,
    nameHospitalDialog,
    perfectDialog,
    advertisementModal,
    emailLoginDialog,
    noauthDialog
  },
  computed: {
    lanuage() {
      return this.$store.state.lanuage
    },
    content() {
      return this.$store.state.content
    },
  },
  data() {
    return {
      dataForm: { // 完善框表单
        phone: '',
        member_id: '',
        name: '',
        hospital_name: '',
        hospital_offices: '',
        job_title: '',
        password: '',
        passwordModify: '',
      },
      perfectPhone: '', // 完善输入框的电话
      isAllowLive: false, // 登录后验证是否可以观看直播
      roomNum: -1, // 房间号
      memberId: '', // 用户Id
      conventionId: -1,
      advShow: false, // 不展示广告
      meetingDetail: {}, // 会议详情
      videoId: undefined, // 默认指定的回放id，主要是针对当会议目录只有一条回放时，自动展示当前回放，否则只会展示会议，没有地方查看回放（只有一个直播或回放时不展示目录）
      perfectDialogIsShow:false,
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/chat-online') {
      console.log(from, 'auth');
      // 只有从主页面来的才初始化详情，从entry来的因为已经执行过则无需重复请求
      sessionStorage.setItem('needInitDetail', '1')
    }
    next()
  },
  async mounted() {
    // alert('哈哈哈哈哈')
    const _this = this
    this.initWxBtns()
    if (sessionStorage.getItem('needInitDetail')) {
      // 只有从主页面来的才初始化详情，从entry来的因为已经执行过则无需重复请求
      sessionStorage.removeItem('needInitDetail')
      await this.initContentDetail()
    }else {
      // 如果路由中带memberId，则先保存至缓存中
      if (this.$route.query.memberId) {
        localStorage.setItem('loginItem', JSON.stringify({ userId: this.$route.query.memberId }))
        this.memberId = this.$route.query.memberId
      } else if (localStorage.getItem('loginItem')) {
        this.memberId = JSON.parse(localStorage.getItem('loginItem')).userId
      }
      if (this.$route.query.live_meeting_id == '2405' && this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
        // 20240129特殊处理：live_meeting_id=2405的会议，如果存放的是游客id 则清空缓存，并让用户重新登录
        localStorage.removeItem('loginItem')
        localStorage.removeItem('x_token')
        this.memberId = ''
      }
    }
    if(this.$route.query.room){
      // 当路由中带room，则按room查询
      this.roomNum = Number(this.$route.query.room)
    }else {
      // 当路由中不带room，则先按会议ID查询第一个直播间ID // 从entry跳过来必带room
    }
    if(this.$route.query.video_id) {
      // 当路由中带video_id，则按video_id查询
      this.videoId = Number(this.$route.query.video_id)
    }
    if(this.roomNum != -1) {
      _this.conventionId = _this.$route.query.conventionId ? Number(_this.$route.query.conventionId) : -1
      _this.checkProtocol()
    } else {
      // 如果直播/回放列表为空，则直接跳去直播页
      this.$router.replace({
        path: '/chat-online',
        query: {
          // memberId: this.memberId,
          room: this.roomNum,
          conventionId: this.$route.query.conventionId,
          openId: this.$route.query.openId,
          live_meeting_id: this.$route.query.live_meeting_id,
          siteId: this.$route.query.siteId,
          video_id: this.videoId, // 回放
        }
      })
    }
  },
  methods: {
    // 当路由中没有room时，查询目录列表获取第一个room展示
    async initContentDetail() {
      // 如果路由中带memberId，则先保存至缓存中
      if (this.$route.query.memberId) {
        localStorage.setItem('loginItem', JSON.stringify({ userId: this.$route.query.memberId }))
        this.memberId = this.$route.query.memberId
      } else if (localStorage.getItem('loginItem')) {
        this.memberId = JSON.parse(localStorage.getItem('loginItem')).userId
      }
      if (this.$route.query.live_meeting_id == '2405' && this.memberId == '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9') {
        // 20240129特殊处理：live_meeting_id=2405的会议，如果存放的是游客id 则清空缓存，并让用户重新登录
        localStorage.removeItem('loginItem')
        localStorage.removeItem('x_token')
        this.memberId = ''
      }
      const res = await postMettingDetail({
        live_metting_id: this.$route.query.live_meeting_id ? Number(this.$route.query.live_meeting_id) : null,
        member_id: this.memberId || '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9' // 游客ID
      })
      this.meetingDetail = res.data
      // 如果至少有一个流，则取第一个，否则房间默认-1
      if (this.meetingDetail.stream_list.length > 0) {
        this.roomNum = this.meetingDetail.stream_list[0].stream_id
      } else {
        this.roomNum = -1
      }
      // 如果只有一个直播流而且是回放，则指定回放id
      if (this.meetingDetail.stream_list.length == 1 && this.meetingDetail.stream_list[0].play_type == 'video') {
        this.videoId = this.meetingDetail.stream_list[0].id
      }
    },
    // 判断缓存中是否有房间号，若没有则提示协议，若有则继续
    async checkProtocol() {
      let hasProtocol = (localStorage.getItem('live_h5_protocol_content'))?true:false;
      console.log('hasProtocol',hasProtocol)
      if (localStorage.getItem('rooms')) {
        let rooms = JSON.parse(localStorage.getItem('rooms'))
        if (rooms.includes(Number(this.roomNum))) {
          // 已同意过该房间协议
          this.getRegisterdInfo()
        } else {
          // let hasProtocol = await this.$refs.policyDialog.getHaveProtocol(Number(this.roomNum),'auth1')

          if (hasProtocol) {
            // 展示协议
            this.$refs.policyDialog.showDialog()
          } else {
            // 没有协议则默认继续
            this.getRegisterdInfo()
          }
        }
      } else {
        // let hasProtocol = await this.$refs.policyDialog.getHaveProtocol(Number(this.roomNum),'auth2')

        if (hasProtocol) {
          // 展示协议
          this.$refs.policyDialog.showDialog()
        } else {
          // 没有协议则默认继续
          this.getRegisterdInfo()
        }
      }
    },
    // 判断是否从微信登录跳转而来
    getRegisterdInfo() {
      const _this = this
      // if (IsWx() && this.lanuage == 'Chinese') {
      //   // 在微信环境中且已经鉴权通过
      //   if(this.$route.query.code) {
      //     // 根据code获取是否注册
      //     // TODO: 根据union_id登录
      //     wechatOfficeLogin({
      //       code: this.$route.query.code
      //     }).then((res) => {
      //       if (res.data.code == 0) {
      //         localStorage.setItem('x_token', res.data.token)
      //         if (res.data.type == 'loginSuccess') {
      //           // 已注册，返回个人信息，判断直播间登录方式
      //           _this.memberId = res.data.memberId
      //           localStorage.setItem(
      //             'loginItem',
      //             JSON.stringify({ userId: _this.memberId })
      //           )
      //           _this.getWxUserInfo()
      //           // 观看权限验证
      //           _this.initWxValidAuth()
      //         } else if (res.data.type == 'needBindTel') {
      //           // 需要绑定手机号
      //           _this.$refs.phoneBindDialog.showDialog()
      //         }
      //       } else {
      //         this.$toast(res.data.message)
      //       }
      //     })
      //   } else {
      //     // 已经微信登录过，点击目录或回放等跳来鉴权
      //     // 观看权限验证
      //     _this.initWxValidAuth()
      //   }
      // } else {
        // 不是从微信登录而来，因此按原逻辑执行
        this.initValidAuth()
      // }
    },
    // 观看权限验证
    async initValidAuth() {
      const _this = this
      if (this.$route.query.conventionId) {
        // 能获取到conventionId
        let memberId = _this.memberId
        let openId = _this.$route.query.openId
        if (memberId || openId) {
          const { data } = await postCheckLoginPay({
            convention_id: _this.$route.query.conventionId,
            member_id: memberId || openId,
          })
          if (data.code == 0) {
            if (data.data.is_need_pay) {
              // 需要缴费
              if (data.data.is_allow_live) {
                // 已缴费，跳转直播页面
                _this.$router.replace({
                  path: '/chat-online',
                  query: {
                    // memberId: memberId || openId,
                    room: _this.roomNum,
                    conventionId: _this.$route.query.conventionId,
                    openId: openId,
                    live_meeting_id: _this.$route.query.live_meeting_id,
                    siteId: _this.$route.query.siteId,
                    video_id: _this.videoId, // 回放
                  }
                })
              } else {
                // 未缴费
                // _this.$toast('很抱歉，您没有直播观看权限')
                _this.$refs.noauthDialog.showDialog()
              }
            } else {
              // 能获取到用户id
              _this.$router.replace({
                path: '/chat-online',
                query: {
                  // memberId: memberId || openId,
                  room: _this.roomNum,
                  conventionId: _this.$route.query.conventionId,
                  openId: openId,
                  live_meeting_id: _this.$route.query.live_meeting_id,
                  siteId: _this.$route.query.siteId,
                  video_id: _this.videoId, // 回放
                }
              })
            }
          } else {
            this.$toast(_this.content.authFail)
          }
        }else {
          const { data } = await postCheckLoginPay({
            convention_id: this.$route.query.conventionId,
            member_id: '78ce3cd0-e42b-11ea-8c91-23f1f183e1f9'
          })
          if (data.code == 0) {
            if (data.data.is_need_pay) {
              // 需要缴费
              // 获取不到用户id，则弹框登录
              if (localStorage.getItem('loginItem') && localStorage.getItem('x_token')) {
                _this.directLogin()
              } else {
                // 提示哪种登录
                await _this.whichLoginType()
              }
            } else {
              // 获取不到用户id，则弹框登录
              if (localStorage.getItem('loginItem') && localStorage.getItem('x_token')) {
                _this.directLogin()
              } else {
                // 提示哪种登录
                await _this.whichLoginType()
              }
            }
          }
        }
      } else {
        // 获取不到conventionId
        let memberId = this.memberId
        let openId = this.$route.query.openId
        if (memberId || openId) {
          // 获取到用户Id
          const { data } = await postCheckLoginPay({
            member_id: memberId || openId,
          })
          if (data.code == 0) {
            if (data.data.is_allow_live) {
              // 鉴权通过，跳转直播页面
              _this.directLogin()
              // _this.$router.replace({
              //   path: '/chat-online',
              //   query: {
              //     // memberId: memberId || openId,
              //     room: _this.roomNum,
              //     openId: openId,
              //     live_meeting_id: _this.$route.query.live_meeting_id,
              //     siteId: _this.$route.query.siteId,
              //     video_id: _this.videoId, // 回放
              //   }
              // })
            } else {
              // 获取不到用户id，则弹框登录
              if (localStorage.getItem('loginItem') && localStorage.getItem('x_token')) {
                _this.directLogin()
              } else {
                // 提示哪种登录
                await _this.whichLoginType()
              }
            }
          } else {
            this.$toast(_this.content.authFail);
          }
        } else {
          // 获取不到用户id，则弹框登录
          if (localStorage.getItem('loginItem') && localStorage.getItem('x_token')) {
            this.directLogin()
          } else {
            // 提示哪种登录
            await _this.whichLoginType()
          }
        }
      }
    },
    // 在微信环境下观看权限验证，跟原逻辑区分：不判断memberId和token自动登录了，因为微信登录执行到这里是一定
    // 带着memberId和token的，如果继续判断就导致永远不会走姓名医院登录
    async initWxValidAuth() {
      const _this = this
      if (this.$route.query.conventionId) {
        // 能获取到conventionId
        let memberId = _this.memberId
        let openId = _this.$route.query.openId
        if (memberId || openId) {
          const { data } = await postCheckLoginPay({
            convention_id: _this.$route.query.conventionId,
            member_id: memberId || openId
          })
          if (data.code == 0) {
            if (data.data.is_need_pay) {
              // 需要缴费
              if (data.data.is_allow_live) {
                // 已缴费，跳转直播页面
                _this.$router.replace({
                  path: '/chat-online',
                  query: {
                    // memberId: memberId || openId,
                    room: _this.roomNum,
                    conventionId: _this.$route.query.conventionId,
                    openId: openId,
                    live_meeting_id: _this.$route.query.live_meeting_id,
                    siteId: _this.$route.query.siteId,
                    video_id: _this.videoId // 回放
                  }
                })
              } else {
                // 未缴费
                // _this.$toast('很抱歉，您没有直播观看权限')
                _this.$refs.noauthDialog.showDialog()
              }
            } else {
              // 能获取到用户id
              _this.$router.replace({
                path: '/chat-online',
                query: {
                  // memberId: memberId || openId,
                  room: _this.roomNum,
                  conventionId: _this.$route.query.conventionId,
                  openId: openId,
                  live_meeting_id: _this.$route.query.live_meeting_id,
                  siteId: _this.$route.query.siteId,
                  video_id: _this.videoId // 回放
                }
              })
            }
          } else {
            this.$toast(_this.content.authFail)
          }
        } else {
          // 提示哪种登录
          await _this.whichLoginType()
        }
      } else {
        // 获取不到conventionId
        // 提示哪种登录
        await _this.whichLoginType()
      }
    },
    // 判断到底是什么登录类型 phone_code:手机号验证码(英文状态下邮箱登录) name_hospital:姓名医院
    async whichLoginType() {
      const _this = this
      let memberId = _this.memberId
      let openId = _this.$route.query.openId
      const res1 = await postLiveMeetDetail({
        live_meet_id: Number(this.roomNum),
        member_id: memberId || openId
      })
      // 判断登录类型 phone_code:手机号验证码 name_hospital:姓名医院
      if (res1.data.login_type == 'name_hospital') {
        // 获取是否在房间中登录过姓名医院
        if (localStorage.getItem('x_room')) {
          let rooms = JSON.parse(localStorage.getItem('x_room'))
          if (rooms.includes(Number(_this.roomNum))) {
            // 已在该房间登录过
            _this.$router.replace({
              path: '/chat-online',
              query: {
                room: _this.roomNum,
                conventionId: _this.$route.query.conventionId,
                openId: _this.$route.query.openId,
                live_meeting_id: _this.$route.query.live_meeting_id,
                siteId: _this.$route.query.siteId,
                video_id: _this.videoId, // 回放
              }
            })
          } else {
            _this.$refs.nameHospitalDialog.showDialog()
          }
        } else {
          _this.$refs.nameHospitalDialog.showDialog()
        }
      } else {
        // if (IsWx()) {
        //   // 在微信登录环境下，如果不是姓名医院登录，则自动登录
        //   _this.$router.replace({
        //     path: '/chat-online',
        //     query: {
        //       room: _this.roomNum,
        //       conventionId: _this.$route.query.conventionId,
        //       openId: _this.$route.query.openId,
        //       live_meeting_id: _this.$route.query.live_meeting_id,
        //       siteId: _this.$route.query.siteId,
        //       video_id: _this.videoId // 回放
        //     }
        //   })
        // } else {
          // 非微信环境下
          if(_this.lanuage == 'Chinese') {
            // 中文状态下手机号登录
            _this.$refs.loginDialog.showDialog()
          }else {
            // 英文状态下邮箱登录
            _this.$refs.emailLoginDialog.showDialog()
          }
        // }
      }
    },
    // 静默登录
    async directLogin() {
      // let loginItem = JSON.parse(localStorage.getItem('loginItem'))
      // 20240119特殊处理：live_meeting_id=2405的会议，已登录的需要再完善资料，未登录的则继续原来的逻辑

      if(this.$route.query.live_meeting_id == '2405') {
        const res1 = await postUserInfo({
          member_id: this.memberId
        })
        if (res1.data.code == 0) {
          this.perfectDialogIsShow = true;
          console.log('执行到这里来吗？')
          this.$nextTick(()=>{
            this.dataForm = { // 完善框表单
              name: res1.data.data.name || '',
              hospital_name: res1.data.data.hospital_name || '',
              hospital_offices: res1.data.data.hospital_offices || '',
              job_title: res1.data.data.job_title || '',
              member_id: this.memberId
            }
            this.perfectPhone = res1.data.data.tel || '';
            this.$refs.perfectDialog.showDialog();
          })
        }
      } else {
        this.$router.replace({
          path: '/chat-online',
          query: {
            // memberId: loginItem.userId,
            room: this.roomNum,
            conventionId: this.$route.query.conventionId,
            openId: this.$route.query.openId,
            live_meeting_id: this.$route.query.live_meeting_id,
            siteId: this.$route.query.siteId,
            video_id: this.videoId, // 回放
          }
        })
      }
    },
    // 需要注册完善
    async needRegister(obj) {
      this.perfectPhone = obj.phone
      const res1 = await postUserInfo({
        member_id: obj.id
      })
      if (res1.data.code == 0) {
        this.perfectDialogIsShow = true;
        console.log('执行到这里来吗2？')
        this.$nextTick(()=>{
          this.dataForm = { // 完善框表单
            name: res1.data.data.name || '',
            hospital_name: res1.data.data.hospital_name || '',
            hospital_offices: res1.data.data.hospital_offices || '',
            job_title: res1.data.data.job_title || '',
            member_id: obj.id
          }
          this.$refs.perfectDialog.showDialog();
        })
      }
    },
    // 登录成功
    async loginSuccess(obj) {
      // 拿到conventionId
      const _this = this
      if (_this.$route.query.conventionId) {
        const res1 = await postCheckLoginPay({
          convention_id: _this.$route.query.conventionId,
          member_id: obj.id,
        })
        if (res1.data.code == 0) {
          if (res1.data.data.is_allow_live) {
            // 可观看，跳转直播页面
            _this.$router.replace({
              path: '/chat-online',
              query: {
                // memberId: obj.id,
                room: _this.roomNum,
                conventionId: _this.$route.query.conventionId,
                openId: _this.$route.query.openId,
                live_meeting_id: _this.$route.query.live_meeting_id,
                siteId: _this.$route.query.siteId,
                video_id: _this.videoId, // 回放
              }
            })
          } else {
            // 不可观看
            // _this.$toast('很抱歉，您没有直播观看权限')
            _this.$refs.noauthDialog.showDialog()
          }
        } else {
          _this.$toast(_this.content.authFail);
        }
      } else {
        // 已注册过
        setTimeout(() => {
          _this.$router.replace({
            path: '/chat-online',
            query: {
              // memberId: obj.id,
              room: _this.roomNum,
              conventionId: _this.$route.query.conventionId,
              openId: _this.$route.query.openId,
              live_meeting_id: _this.$route.query.live_meeting_id,
              siteId: _this.$route.query.siteId,
              video_id: _this.videoId, // 回放
            }
          })
        }, 400)
      }
    },
    // 登录失败
    loginFail() { },
    // 邮箱登录失败
    emailLoginFail() {},
    // 游客身份观看
    visitorLogin() {
      this.$router.replace({
        path: '/chat-online',
        query: {
          room: this.roomNum,
          conventionId: this.$route.query.conventionId,
          openId: this.$route.query.openId,
          live_meeting_id: this.$route.query.live_meeting_id,
          siteId: this.$route.query.siteId,
          video_id: this.videoId, // 回放
        }
      })
    },
    // 姓名医院登录
    nameHospitalSuccess() {
      this.$router.replace({
        path: '/chat-online',
        query: {
          room: this.roomNum,
          conventionId: this.$route.query.conventionId,
          openId: this.$route.query.openId,
          live_meeting_id: this.$route.query.live_meeting_id,
          siteId: this.$route.query.siteId,
          video_id: this.videoId, // 回放
        }
      })
    },
    // 完善成功
    async perfectSuccess(obj) {
      // 拿到conventionId
      const _this = this
      if (_this.$route.query.conventionId) {
        const res1 = await postCheckLoginPay({
          convention_id: _this.$route.query.conventionId,
          member_id: obj.id,
        })
        if (res1.data.code == 0) {
          if (res1.data.data.is_allow_live) {
            // 可观看，跳转直播页面
            _this.$router.replace({
              path: '/chat-online',
              query: {
                // memberId: obj.id,
                room: _this.roomNum,
                conventionId: _this.$route.query.conventionId,
                openId: _this.$route.query.openId,
                live_meeting_id: _this.$route.query.live_meeting_id,
                siteId: _this.$route.query.siteId,
                video_id: _this.videoId, // 回放
              }
            })
          } else {
            // 不可观看
            // _this.$toast('很抱歉，您没有直播观看权限')
            _this.$refs.noauthDialog.showDialog()
          }
        } else {
          _this.$toast(_this.content.authFail);
        }
      } else {
        setTimeout(() => {
          _this.$router.replace({
            path: '/chat-online',
            query: {
              // memberId: obj.id,
              room: _this.roomNum,
              conventionId: _this.$route.query.conventionId,
              openId: _this.$route.query.openId,
              live_meeting_id: _this.$route.query.live_meeting_id,
              siteId: _this.$route.query.siteId,
              video_id: _this.videoId, // 回放
            }
          })
        }, 400)
      }
    },
    // 手机号绑定成功
    async bindSuccess(memberId) {
      // 绑定手机号成功后，保存memberId，并验证观看权限
      this.memberId = memberId
      localStorage.setItem(
        'loginItem',
        JSON.stringify({ userId: this.memberId })
      )
      // 获取用户信息展示头像
      this.getWxUserInfo()
      // 观看权限验证
      this.initWxValidAuth()
    },
    // 手机号绑定失败
    bindFail() {},
    // 获取用户信息，用于微信登录后获取头像等展示
    getWxUserInfo() {
      postUserInfo({
        member_id: this.memberId
      }).then(res => {
        if (res.data.code == 0) {
          this.$store.commit('saveUserInfo', res.data.data)
        }
      })
    },
    // 同意隐私条款
    agreePolicy() {
      // 继续鉴权
      this.getRegisterdInfo()
    },
    // 查看隐私协议，仅查看
    lookPolicy() {
      this.$refs.policyDialog.showDialogWithoutCheck()
    },
    // 结束广告
    advertiseEnd(){
      this.conventionId = this.$route.query.conventionId ? Number(this.$route.query.conventionId) : -1
      this.checkProtocol()
    },
    // 初始化微信按钮
    initWxBtns() {
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    },
    // DES加密
    encryptDes(message, key) {
      let keyHex = cryptoJs.enc.Utf8.parse(key)
      let option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
      let encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
      return encrypted.ciphertext.toString()
    },
    // DES解密
    decryptDes(message, key) {
      let keyHex = cryptoJs.enc.Utf8.parse(key)
      let decrypted = cryptoJs.DES.decrypt(
        {
          ciphertext: cryptoJs.enc.Hex.parse(message)
        },
        keyHex,
        {
          mode: cryptoJs.mode.ECB,
          padding: cryptoJs.pad.Pkcs7
        }
      )
      return decrypted.toString(cryptoJs.enc.Utf8)
    }
  },
}
</script>

<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.auth-container {
  background-color: #fff;
}
.van-dialog {
  border-radius: 6px;
}
.login-content {
  height: 3.7rem;
  padding: 0 0.25rem;
  .title {
    font-size: 0.23rem;
    color: #131313;
    font-weight: bold;
    text-align: center;
    margin-top: 0.33rem;
    margin-bottom: 0.5rem;
  }
  .van-cell {
    margin-top: 0.1rem;
    padding: 0.13333rem 0;
  }
  .loginBtn {
    width: 2.8rem;
    height: 0.45rem;
    margin: 0.45rem auto 0.65rem;
    display: block;
  }
}
.perfect-content {
  // height: 4.5rem;
  padding: 0 0.25rem;
  .title {
    font-size: 0.23rem;
    color: #131313;
    font-weight: bold;
    text-align: center;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }
  .van-cell {
    // margin-top: 0.1rem;
    padding: 0.13333rem 0;
  }
  .perfectBtn {
    width: 2.8rem;
    height: 0.45rem;
    margin: 0.25rem auto 0.45rem;
    display: block;
  }
}
/deep/.van-popup{
  position: absolute;
}
</style>
